import { Box, Card, Stack, Typography, ValidationErrors } from "@compass/core";
import {
  ContributorEmployment as ContributorEmploymentModel,
  ContributorEmploymentEditResource,
  ContributorEmploymentViewResource,
} from "generated/openApi";
import { ContributorEmploymentPageBody } from "pages/match-main/contributor-employments/ContributorEmploymentPage/ContributorEmploymentPageBody";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const ContributorEmployment = (props: {
  employment: ContributorEmploymentModel;
  setEmployment: (value: ContributorEmploymentModel) => void;
  validationErrors: ValidationErrors | string[];
}) => {
  const [viewResource, setViewResource] = useState<ContributorEmploymentViewResource>({});
  const [editResource, setEditResource] = useState<ContributorEmploymentEditResource>({});

  useEffect(() => {
    fetchEditResource();
    fetchViewResource();
  }, []);

  const fetchEditResource = () => {
    ApiService.contributorEmployments.getEditResource().then((response) => {
      setEditResource(response);
    });
  };

  const fetchViewResource = () => {
    ApiService.contributorEmployments.getViewResource().then((response) => {
      setViewResource(response);
    });
  };

  return (
    <Card
      header={
        <Stack>
          <Box>Employment</Box>
          <Typography variant="caption">
            An employment is required when creating a contributor. You may add more employments after succesfully
            creating this contributor.
          </Typography>
        </Stack>
      }
    >
      <ContributorEmploymentPageBody
        crudMode="edit"
        employment={props.employment}
        setEmployment={(value) => props.setEmployment(value)}
        viewResource={viewResource}
        editResource={editResource}
        validationErrors={props.validationErrors}
      />
    </Card>
  );
};
